mutation CancelAssistantPlan($id: ID!) {
  cancelAssistantPlan(id: $id) {
    id
    status
  }
}
